function CarouselBanner({ item }) {
    return (
        <div className='w-full h-auto'>
            <img className='size-full' src={item?.imageLink} alt={item?.altText} />
        </div>
    );
}

export default CarouselBanner;
